import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';
import { DEFAULT_CENTER_ID, isValidCenterId } from '../../enums/centerTypes';

const CHATBOT_POSITION_STORAGE_KEY = 'castle-chatbot-launcher-position';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    accessToken: null,
    userData: { FirstName: null, LastName: null },
    ferpaEnabled: null,
    selectedAssignmentId: null,
    accessTokenExpiration: null,
    superAdminPasswordRequired: false,
    isUsedDefaultPassword: false,
    isRedirectionRequired: false,
    currentCenter: DEFAULT_CENTER_ID
  },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken, superAdminPasswordRequired, isUsedDefaultPassword, isRedirectionRequired } = action.payload;
      state.accessToken = accessToken;
      state.superAdminPasswordRequired = superAdminPasswordRequired;
      state.isUsedDefaultPassword = isUsedDefaultPassword;
      state.isRedirectionRequired = isRedirectionRequired;
      // Get userData and UserName from decoded accessToken
      const decodedToken = jwtDecode(accessToken);
      state.accessTokenExpiration = new Date(decodedToken.exp * 1000).toString();
      state.userData = JSON.parse(
        decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata']
      );
      state.user = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    },
    logOut: (state) => {
      state.user = null;
      state.accessToken = null;
      state.userData = null;
      state.accessTokenExpiration = null;
      state.superAdminPasswordRequired = false;
      state.isUsedDefaultPassword = false;
      state.isRedirectionRequired = false;
      Cookies.remove('LOGIN');
      Cookies.remove('SID');
      Cookies.remove('KEY');
      Cookies.remove('ASP.NET_SessionId');
      window.localStorage.removeItem(CHATBOT_POSITION_STORAGE_KEY);
      state.currentCenter = DEFAULT_CENTER_ID;
    },
    setFerpaState: (state, action) => {
      const { ferpaEnabled } = action.payload;
      state.ferpaEnabled = ferpaEnabled;
    },
    setSelectedAssignmentId: (state, action) => {
      const { assignmentId } = action.payload;
      state.selectedAssignmentId = assignmentId;
    },
    setCurrentCenter: (state, action) => {
      const { currentCenter } = action.payload;
      const normalizedCenterId = Number(currentCenter);
      state.currentCenter = isValidCenterId(normalizedCenterId)
        ? normalizedCenterId
        : DEFAULT_CENTER_ID;
    },
  }
});

export const { setCredentials, logOut } = authSlice.actions;
export const { setFerpaState, setSelectedAssignmentId, setCurrentCenter } = authSlice.actions;

export const globalLogout = () => (dispatch) => {
  localStorage.setItem('logout', Date.now());
  dispatch(logOut());
};

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.accessToken;
export const selectSuperAdminPasswordRequired = (state) => state.auth.superAdminPasswordRequired;
export const selectIsUsedDefaultPassword = (state) => state.auth.isUsedDefaultPassword;
export const selectIsRedirectionRequired = (state) => state.auth.isRedirectionRequired;
export const selectCurrentUserData = (state) => state.auth.userData;
export const selectFerpaState = (state) => state.auth.ferpaEnabled;
export const selectSelectedAssignmentId = (state) => state.auth.selectedAssignmentId;
export const selectCurrentCenter = (state) => state.auth.currentCenter;